var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',{attrs:{"icon":"","fab":""},on:{"click":_vm.downloadTable}},[_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.dark ? 'white' : ''}},'v-icon',attrs,false),on),[_vm._v(" mdi-download ")])],1)]}}])},[_c('span',[_vm._v("Export to Excel")])])}
var staticRenderFns = []

export { render, staticRenderFns }